module.exports = __webpack_public_path__ + "static/icons/icon-caret-up-59e13e6e5959a56bf77bae54356d6ebc.svg";